import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';
import { useTests } from '../../hooks/tests';

import { AssignmentCard } from '../assignment-card';
import { LoadFailed } from '../load-failed';

import styles from './style.module.css';

// The Tests section: the questionnaires assigned now, as cards to start or
// continue, and under them everything already submitted, each opening the
// answers as they were sent. Completed appears once there is something in it.
export function Tests() {
  const { text, language } = useLanguage();
  const { tests, error, retry } = useTests();

  if (error != null) {
    return <LoadFailed onRetry={ retry }/>;
  }

  if (tests === undefined) {
    return null;
  }

  let assigned = <p className={ styles.empty }>{ text.nothingAssigned }</p>;

  if (tests.assigned.length > 0) {
    assigned = (
      <div className={ styles.grid }>
        {
          tests.assigned.map(function(assignment) {
            return <AssignmentCard key={ assignment.id } assignment={ assignment }/>;
          })
        }
      </div>
    );
  }

  let completed = null;

  if (tests.submitted.length > 0) {
    const rows = tests.submitted.map(function({ id, submittedAt, questionnaire }) {
      return (
        <Link key={ id } className={ styles.row } to={ `/tests/${ id }/check` }>
          <span className={ styles.what }>
            <span className={ styles.name }>{ questionnaire.name }</span>
            <span className={ styles.when }>{ text.submittedOn.replace('{date}', describe({ day: dayOf(submittedAt), language, short: true })) }</span>
          </span>

          <span className={ styles.chip }>{ text.submitted }</span>

          <span className={ styles.chevron } aria-hidden='true'></span>
        </Link>
      );
    });

    completed = (
      <section className={ styles.group } aria-labelledby='tests-completed'>
        <h2 id='tests-completed' className={ styles.heading }>{ text.completedTests }</h2>

        <div className={ styles.list }>{ rows }</div>
      </section>
    );
  }

  return (
    <section className={ styles.tests }>
      <h1 className={ styles.title }>{ text.tests }</h1>

      <section className={ styles.group } aria-labelledby='tests-assigned'>
        <h2 id='tests-assigned' className={ styles.heading }>{ text.assignedToYou }</h2>

        { assigned }
      </section>

      { completed }
    </section>
  );
}
